import { format } from "date-fns";

export function calculateAge(dob) {
  // convert user input value into date object
  var birthDate = new Date(dob);

  // get difference from current date;
  var difference = Date.now() - birthDate.getTime();

  var ageDate = new Date(difference);
  var calculatedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
  return calculatedAge;
}

export function isEmpty(obj) {
  return obj && Object.keys(obj).length === 0;
}

export function getFullName(patientProfile) {
  return `${patientProfile.firstName} ${patientProfile.middleName} ${patientProfile.lastName}`;
}

export function formatDuration(durationText) {
  const dVal = Number(durationText.replace(/[^0-9]/g, ""));
  const dUnit = durationText.replace(/[0-9]/g, "");
  if (dVal == 0) {
    return "";
  } else if (dVal > 1) {
    return dVal.toString() + " " + dUnit + "s";
  } else {
    return dVal.toString() + " " + dUnit;
  }
}

export function getFrequencyText(code) {
  switch (code) {
    case 1:
      return "Once a week";
    case 2:
      return "Twice a week";
    case 3:
      return "Thrice a week";
    case 4:
      return "Four times a week";
    case 5:
      return "Five times a week";
    case 6:
      return "Six times a week";
    case 7:
      return "Everyday";
    default:
      return "";
  }
}

export function getFormattedDate(date) {
  return format(new Date(date), "dd LLL yyyy");
}

export function convertDecimalDosage(number) {
  if (number % 1 === 0.5) {
    const wholeNumber = Math.floor(number);
    return wholeNumber == 0
      ? String.fromCharCode(189)
      : `${wholeNumber} ${String.fromCharCode(189)}`;
  } else {
    return number.toString();
  }
}

export const formatMedicineStrength = (strength) =>
  strength.replace(/[^0-9.]/g, "") == 0 ||
  strength.replace(/[0-9.\s]/g, "") == "NA"
    ? ""
    : strength;

// Overide Function for special ask. For Dr Akerker and Dr Aarti crossover Clinics, Show both Dr names at bottom.
export const isAkerkerAartiCrossoverClinic = (drId, clinicId) => {
  const DR_AKERKER_ID = "DR000001";
  const DR_AARTI_ID = "DR000005";

  return drId === DR_AKERKER_ID ||
    (drId === DR_AARTI_ID && clinicId === "CC000001") ||
    clinicId === "CC000002" ||
    clinicId === "CC000003"
    ? true
    : false;
};

export function getClinicEmail(clinicId) {
  switch (clinicId) {
    case "CC000006":
      return "care@ic4.health";
    case "CC000009":
      return "spandanhealthcarecenter@gmail.com";
    case "CC000011":
      return "drgmanojclinic@gmail.com";
    case "CC000012":
      return "drgmanojclinic@gmail.com";
    case "CC000013":
      return "drgmanojclinic@gmail.com";
    default:
      return "standforas@ic4.health";
  }
}

export function getDoctorsRegistrationNumber(doctorId) {
  switch (doctorId) {
    case "DR000001":
      return "2000/02/1363";
    case "DR000005":
      return "2014/04/1581";

    default:
      return "";
  }
}
